module.exports = __webpack_public_path__ + "media/images/rapidity-81316488bd5841ddf5036903ee74c584.svg";